export default {
  isDrawerOpen: ({ drawerOpen }) => drawerOpen,
  msg: ({ msg }) => msg,
  alertType: ({ alertType }) => alertType,
  isLoading: ({ isLoading }) => isLoading,
  changelogDialog: ({ changelogDialog }) => changelogDialog,
};
